import React, { useState } from "react";
import KilometerCar from "../../kilometer";
import Pelak from "../../pelak-car";
import { CiEdit } from "react-icons/ci";
import { Link } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import DeleteCar from "../delete/delete-car";
import EditKilometer from "./edit-kilometer";
import styles from "./CardSingleTop.module.css";

const CardSingleTop = ({ car }) => {
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenEditKilometer, setIsOpenEditKilometer] = useState(false);

  const imageSrc = car.imageUrl || "/default-avatar.png";

  return (
    <div className={`card shadow-sm h-100 ${styles.card}`}>
      
      {/* تصویر فقط برای دسکتاپ */}
      <div className="d-none d-md-block">
        <div
          className={styles.imageWrapper}
          style={{ "--bg-image": `url(${imageSrc})` }}
        >
          <img
            src={imageSrc}
            alt="خودرو"
            className={styles.mainImage}
          />
        </div>
      </div>

      <div className="card-body">

        {/* ردیف موبایل: تصویر + اطلاعات */}
        <div className="row align-items-center mb-2 d-md-none">
          <div className="col">
            <div className="mb-1 row">
              <div className="col-4 text-start">{car.productYear}</div>
              <div className="col-8 text-end fw-bold">{car.title}</div>
            </div>

            <div className="mb-1 row">
              <div className="col-4 text-start">{car.distancePerWeek}</div>
              <div className="col-8 text-end fw-bold">
                :حرکت هفتگی(کیلومتر)
              </div>
            </div>
          </div>

          {/* تصویر دایره‌ای موبایل */}
          <div className="col-auto">
            <div className={styles.imageWrapper}>
              <img
                src={imageSrc}
                alt="خودرو"
                className={styles.mainImage}
              />
            </div>
          </div>
        </div>

        {/* اطلاعات دسکتاپ */}
        <div className="row align-items-start d-none d-md-flex">
          <div className="col">
            <div className="mb-2 row">
              <div className="col-4 text-start">{car.productYear}</div>
              <div className="col-8 text-end fw-bold">{car.title}</div>
            </div>

            <div className="mb-2 row">
              <div className="col-4 text-start">{car.distancePerWeek}</div>
              <div className="col-8 text-end fw-bold">
                :حرکت هفتگی(کیلومتر)
              </div>
            </div>
          </div>
        </div>

        {/* کیلومتر + پلاک (مشترک موبایل و دسکتاپ) */}
        <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
          <div className="flex-fill">
            <div className="d-flex align-items-center gap-2">
              <div className="flex-grow-1">
                <KilometerCar kilometer={car.kilometer} />
              </div>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setIsOpenEditKilometer(true)}
              >
                <CiEdit size={18} />
              </button>
            </div>
          </div>

          <div className={`flex-fill ${styles.pelakWrapper}`}>
            <Pelak
              part1Pelak={car.pelak1}
              part2Pelak={car.pelak2}
              part3Pelak={car.pelak3}
              part4Pelak={car.pelak4}
            />
          </div>
        </div>
      </div>

      {/* فوتر */}
      <div className="card-footer text-muted">
        <div className="d-flex gap-2">
          <Link
            className="btn btn-outline-info btn-sm flex-fill"
            to={`/edit-car/${car.id}`}
          >
            <CiEdit size={18} /> ویرایش
          </Link>

          <button
            className="btn btn-outline-danger btn-sm flex-fill"
            onClick={() => setIsOpenDelete(true)}
          >
            <RiDeleteBinLine size={18} /> حذف
          </button>
        </div>
      </div>

      {/* BottomSheet حذف */}
      <BottomSheet
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        snapPoint="250"
      >
        <DeleteCar
          car={car}
          closeButtomSheetHandler={() => setIsOpenDelete(false)}
        />
      </BottomSheet>

      {/* BottomSheet ویرایش کیلومتر */}
      <BottomSheet
        isOpen={isOpenEditKilometer}
        onClose={() => setIsOpenEditKilometer(false)}
        snapPoint="250"
      >
        <EditKilometer
          car={car}
          closeButtomSheetHandler={() =>
            setIsOpenEditKilometer(false)
          }
        />
      </BottomSheet>
    </div>
  );
};

export default CardSingleTop;
